//index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import logger from './Utils/logger';
import ErrorBoundary from './Utils/ErrorBoundary';

import 'primereact/resources/themes/saga-blue/theme.css';
import 'primereact/resources/primereact.min.css';
import 'primeicons/primeicons.css';
import 'bootstrap/dist/css/bootstrap.min.css';

// --- Blindaje contra traducción del DOM (Google Translate / extensiones) ---
// Cuando el navegador o una extensión traduce la página, envuelve los nodos de
// texto en <font> y los reemplaza. React conserva referencias a los nodos
// originales y al re-renderizar revienta con NotFoundError en removeChild/
// insertBefore (botones que "no responden", pantallas en blanco). Estas guardas
// convierten esa operación imposible en un no-op en vez de una excepción.
// Ver también public/index.html (lang="es", translate="no", <meta notranslate>).
if (typeof Node === 'function' && Node.prototype) {
  const originalRemoveChild = Node.prototype.removeChild;
  Node.prototype.removeChild = function (child) {
    if (child.parentNode !== this) {
      logger.warn('removeChild: nodo ya no es hijo de este padre (DOM traducido?)');
      return child;
    }
    return originalRemoveChild.apply(this, arguments);
  };

  const originalInsertBefore = Node.prototype.insertBefore;
  Node.prototype.insertBefore = function (newNode, referenceNode) {
    if (referenceNode && referenceNode.parentNode !== this) {
      logger.warn('insertBefore: nodo de referencia con otro padre (DOM traducido?)');
      return newNode;
    }
    return originalInsertBefore.apply(this, arguments);
  };
}

// Errores globales que no pasan por un componente React (handlers, promesas sin catch).
window.addEventListener('error', (e) => {
  logger.error('window.onerror: ' + (e.message || 'error'), e.error || e.message, `${e.filename || ''}:${e.lineno || ''}`);
});
window.addEventListener('unhandledrejection', (e) => {
  logger.error('unhandledrejection', e.reason);
});

// Cargar config.json antes de renderizar la app
// Ruta absoluta (con BrowserRouter './' se resuelve contra la ruta actual) y sin
// caché (si no, un cambio de config.json en el servidor no se ve hasta limpiar caché).
fetch(`${process.env.PUBLIC_URL}/config.json`, { cache: 'no-store' })
  .then(response => {

    if (!response.ok) {
      logger.warn('config.json no encontrado');
      throw new Error('config.json no encontrado');
    }

    return response.json();
  })
  .then(config => {

    // Solo guardar configuración de la aplicación
    const configKeys = [
      'gApiUrl',
      'gColorCorp',
      'gColorCorpTitle',
      'gColorCorpLabel',
      'gColorLetraMenu',
      'gBackground',
      'gTitle',
      'siteKey',
      'siteKeyV3'
    ];

    // La llave secreta del reCAPTCHA nunca debe vivir en el navegador:
    // limpiar la que hayan dejado versiones anteriores en esta sesión.
    sessionStorage.removeItem('secretKey');
    // Lo mismo con la clave Basic fija del API (reemplazada por el token de sesión).
    sessionStorage.removeItem('gUserApi');
    sessionStorage.removeItem('gPassApi');

    configKeys.forEach(key => {
      if (config[key] !== undefined) {
        sessionStorage.setItem(key, config[key]);
      }
    });

  })
  .catch(error => {

    logger.error('Error cargando config.json:', error);
       
  })
  .finally(() => {

    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
      <React.StrictMode>
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </React.StrictMode>
    );

  });